import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AppProvider } from "./store";
import Header from "./components/Header";
import Footer from "./components/Footer";
import FloatingChat from "./components/FloatingChat";
import Breadcrumbs from "./components/Breadcrumbs";
import SeoHead from "./components/SeoHead";
import HomeFinal from "./pages/HomeFinal";
import ProductList from "./pages/ProductList";
import ProductDetail from "./pages/ProductDetail";
import UltraAI from "./pages/UltraAI";
import BookDemo from "./pages/BookDemo";
import { BlogList, BlogPost } from "./pages/Blog";
import Contact from "./pages/Contact";
import Support from "./pages/Support";
import Warranty from "./pages/Warranty";
import WarrantyRequest from "./pages/WarrantyRequest";
import WarrantyTracking from "./pages/WarrantyTracking";
import TechnicalSupportRequest from "./pages/TechnicalSupportRequest";
import TechnicalSupportTracking from "./pages/TechnicalSupportTracking";
import FAQ from "./pages/FAQ";
import Cart from "./pages/Cart";
import { CheckoutSuccess, CheckoutCancel } from "./pages/Checkout";
import PixCheckout from "./pages/PixCheckout";
import UsdtCheckout from "./pages/UsdtCheckout";
import { Wishlist, Compare } from "./pages/WishlistCompare";
import AdminLogin from "./pages/AdminLogin";
import Admin from "./pages/Admin";
import { Toaster } from "./components/ui/sonner";

function ScrollToTop() {
  const { pathname } = useLocation();
  React.useEffect(() => { window.scrollTo({ top: 0, behavior: "smooth" }); }, [pathname]);
  return null;
}

function Layout({ children, noChat }) {
  const location = useLocation();
  const disableChat = noChat || location.pathname.startsWith("/support") || location.pathname.startsWith("/book");
  return (
    <>
      <SeoHead />
      <Header />
      <Breadcrumbs />
      {children}
      <Footer />
      {!disableChat && <FloatingChat />}
    </>
  );
}

function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <ScrollToTop />
        <div className="App">
          <Routes>
            <Route path="/" element={<Layout><HomeFinal /></Layout>} />
            <Route path="/home-final" element={<Layout><HomeFinal /></Layout>} />
            <Route path="/products" element={<Navigate to="/products/efoils" replace />} />
            <Route path="/products/SharkX-Ultra-AI-electric-jetski" element={<Layout><UltraAI /></Layout>} />
            <Route path="/products/sharkx-ultra-ai-electric-jetski" element={<Layout><UltraAI /></Layout>} />
            <Route path="/products/ultra_ai" element={<Layout><UltraAI /></Layout>} />
            <Route path="/products/:category" element={<Layout><ProductList /></Layout>} />
            <Route path="/product/:slug" element={<Layout><ProductDetail /></Layout>} />
            <Route path="/ultra-ai" element={<Layout><UltraAI /></Layout>} />
            <Route path="/book" element={<Layout><BookDemo /></Layout>} />
            <Route path="/book-demo" element={<Layout><BookDemo /></Layout>} />
            <Route path="/blog" element={<Layout><BlogList /></Layout>} />
            <Route path="/blog/:slug" element={<Layout><BlogPost /></Layout>} />
            <Route path="/contact" element={<Layout><Contact /></Layout>} />
            <Route path="/warranty" element={<Layout><Warranty /></Layout>} />
            <Route path="/warranty/request" element={<Layout><WarrantyRequest /></Layout>} />
            <Route path="/warranty/request/:id" element={<Layout><WarrantyTracking /></Layout>} />
            <Route path="/faq" element={<Layout><FAQ /></Layout>} />
            <Route path="/support" element={<Layout><Support /></Layout>} />
            <Route path="/support/technical-request" element={<Layout><TechnicalSupportRequest /></Layout>} />
            <Route path="/support/technical-request/:id" element={<Layout><TechnicalSupportTracking /></Layout>} />
            <Route path="/cart" element={<Layout><Cart /></Layout>} />
            <Route path="/checkout/success" element={<Layout><CheckoutSuccess /></Layout>} />
            <Route path="/checkout/cancel" element={<Layout><CheckoutCancel /></Layout>} />
            <Route path="/checkout/pix-success" element={<Layout><PixCheckout /></Layout>} />
            <Route path="/checkout/usdt/:orderId" element={<Layout><UsdtCheckout /></Layout>} />
            <Route path="/wishlist" element={<Layout><Wishlist /></Layout>} />
            <Route path="/compare" element={<Layout><Compare /></Layout>} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/*" element={<Admin />} />
            {/* Catch-all: redirect unknown paths to home */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster />
        </div>
      </BrowserRouter>
    </AppProvider>
  );
}

export default App;
